import type { AxiosRequestConfig } from 'axios'
import type { IPageContainer, IPageContainerCreateUpdate } from '~/types/page-container'
import type { ITranslationRuleError } from '~/types/translation'

import config from '~/config'
import { request } from '~/utils/request'

export interface IInfinitePaginatedResponse<T> {
  data: T[] | null
  page: number
  total: number
}

export const getPageContainers = (
  params?: AxiosRequestConfig['params']
): Promise<IPaginatedResponse<IPageContainer>> => {
  return request({
    params,
    url: `${config.DYNAMIC_SCREEN_API}/page-containers`,
  })
}

export const createPageContainerFromTemplate = ({
  appKey,
  deviceType,
  isUnity,
  templateKey,
  templateVersion,
  ...data
}: IPageContainerCreateUpdate): Promise<IPageContainer> => {
  return request({
    data: {
      ...data,
      app_key: appKey,
      device_type: deviceType,
      is_unity: isUnity,
      template_key: templateKey,
      template_version: templateVersion,
    },
    method: 'POST',
    url: `${config.DYNAMIC_SCREEN_API}/templates/processor/page-containers`,
  })
}

export const updatePageContainerFromTemplateProcessor = ({
  data: { appKey, deviceType, screenshotFileIds, templateKey, templateVersion, ...data },
  id,
}: {
  data: IPageContainerCreateUpdate
  id: string
}): Promise<IPageContainer> => {
  return request({
    data: {
      ...data,
      app_key: appKey,
      device_type: deviceType,
      screenshot_file_ids: screenshotFileIds,
      template_key: templateKey,
      template_version: templateVersion,
    },
    method: 'PUT',
    url: `${config.DYNAMIC_SCREEN_API}/templates/processor/page-containers/${id}`,
  })
}

export const getPageContainer = (id: string): Promise<IPageContainer> => {
  return request({
    url: `${config.DYNAMIC_SCREEN_API}/page-containers/${id}`,
  })
}

export const createPageContainer = (data: IPageContainer): Promise<IPageContainer> => {
  return request({
    data,
    method: 'POST',
    url: `${config.DYNAMIC_SCREEN_API}/page-containers`,
  })
}

export const processPageContainer = (id: string): Promise<IPageContainer> => {
  return request({
    method: 'POST',
    url: `${config.DYNAMIC_SCREEN_API}/templates/processor/page-containers/${id}/process`,
  })
}

export const compilePageContainer = (id: string): Promise<void> => {
  return request({
    method: 'POST',
    url: `${config.DYNAMIC_SCREEN_API}/templates/processor/page-containers/${id}/compile`,
  })
}

export const checkPageContainerTranslations = (id: string): Promise<{ data: ITranslationRuleError[] | null }> => {
  return request({
    method: 'POST',
    url: `${config.DYNAMIC_SCREEN_API}/templates/processor/page-containers/${id}/check-translation`,
  })
}

export const updatePageContainer = ({
  id,
  screenshotFileIds,
  title,
}: {
  id: string
  screenshotFileIds: string[]
  title?: string
}): Promise<void> => {
  return request({
    data: { screenshot_file_ids: screenshotFileIds, title },
    method: 'PUT',
    url: `${config.DYNAMIC_SCREEN_API}/v2/page-containers/${id}`,
  })
}
